﻿(function () {

    "use strict";

    let config;

    let modal;
    let mobileInput;
    let validationMessage;
    let saveButton;
    let snoozeButton;

    let eventsBound = false;

    // Tracks whether the modal is currently visible
    let modalVisible = false;

    function initialize() {

        config = window.profileUpdateReminder;

        if (!config || !config.showReminder) {
            return;
        }

        cacheElements();

        if (!modal ||
            !mobileInput ||
            !validationMessage ||
            !saveButton ||
            !snoozeButton) {
            return;
        }

        loadProfile();
    }

    function cacheElements() {

        modal =
            document.getElementById(
                "profile-update-reminder-modal");

        mobileInput = document.getElementById("profile-update-mobile-number");

        validationMessage = document.getElementById("profile-update-validation");

        saveButton = document.getElementById("profile-update-save-btn");

        snoozeButton = document.getElementById("profile-update-snooze-btn");
    }

    function bindEvents() {

        if (eventsBound) {
            return;
        }

        saveButton.addEventListener("click", saveProfile);
        snoozeButton.addEventListener("click", snoozeReminder);

        mobileInput.addEventListener("input", function () {

            if (mobileInput.value.trim()) {
                clearValidation();
            }

        });

        eventsBound = true;
    }

    function loadProfile() {

        disableButtons();

        executeAjax({

            url: config.profileUrl,

            type: "GET",

            success: function (response) {

                if (!response) {

                    console.error(
                        config.loadProfileErrorMessage);

                    return;
                }

                mobileInput.value = (response.MobileNumber || "").trim();

                clearValidation();
                bindEvents();
                enableButtons();
                showModal();
            },

            error: function (err) {

                console.error(
                    config.loadProfileErrorMessage,
                    err);
            }

        });
    }

    function showModal() {

        modalVisible = true;
        modal.classList.add("show");
    }

    function hideModal() {

        modalVisible = false;
        modal.classList.remove("show");
        clearValidation();
        mobileInput.value = "";
    }

    function validate() {

        clearValidation();

        const mobileNumber = mobileInput.value.trim();

        if (!mobileNumber) {

            showValidation(config.mobileRequiredMessage);

            return false;
        }

        return true;
    }

    function saveProfile() {

        if (!validate()) {
            return;
        }

        disableButtons();

        const mobileNumber = mobileInput.value.trim();

        executeAjax({

            url: config.updateProfileUrl,

            type: "POST",

            contentType: "application/json",

            data: JSON.stringify({
                mobileNumber: mobileNumber
            }),

            success: function () {

                hideModal();
                enableButtons();
            },

            error: function (err) {

                enableButtons();

                console.error(
                    config.updateProfileErrorMessage,
                    err);
            }

        });
    }

    function snoozeReminder() {

        disableButtons();

        executeAjax({

            url: config.snoozeUrl,

            type: "POST",

            success: function () {

                hideModal();

                enableButtons();
            },

            error: function (err) {

                enableButtons();

                console.error(
                    config.snoozeErrorMessage,
                    err);
            }

        });
    }
    function disableButtons() {

        saveButton.disabled = true;
        snoozeButton.disabled = true;
    }

    function enableButtons() {

        saveButton.disabled = false;
        snoozeButton.disabled = false;
    }

    function executeAjax(options) {

        $.ajax(options);
    }

    function showValidation(message) {

        mobileInput.classList.add("input-validation-error");
    }

    function clearValidation() {

        mobileInput.classList.remove("input-validation-error");
    }

    /*
 * Prevent closing the popup by clicking outside.
 * Same behavior as Session Timeout popup.
 */
    document.addEventListener("click", function (event) {

        if (!modalVisible) {
            return;
        }

        // Allow clicks inside the popup
        if (event.target.closest(".lm__information-modal")) {
            return;
        }

        // Prevent any outside click from reaching
        // global modal handlers.
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

    }, true);

    initialize();

})();